import '../styles/embeddedVideoOnPopup.scss';
import $ from 'jquery';

export const tag = `
<div class="wrapper-inmodal">
  <div class="video-container">
    <video controls autoplay webkit-playsinline playsinline>
      Your browser does not support the video tag.
    </video>
  </div>
</div>
`.trim();


export function init(videoModal, context, productNotice = null, completeCallback = null) {
  const videoElement = $('video', videoModal);
  const wrapperElement = $('.wrapper-inmodal', videoModal);
  if (context.videoId) { 
    videoElement.attr('src', context.videoId);
  }
  videoElement[0].addEventListener('ended', function() {
    if (completeCallback) completeCallback(this);
  });
}